module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cpn"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/fm"
    }
  }, [_vm._v("“But Didn’t They "), _c('em', [_vm._v("Smell")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01"
    }
  }, [_c('strong', [_vm._v("ONE")]), _c('br'), _vm._v("The Social Bath: Greeks and Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("TWO")]), _c('br'), _vm._v("Bathed in Christ: 200–1000")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THREE")]), _c('br'), _vm._v("A Steamy Interlude: 1000–1550")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FOUR")]), _c('br'), _vm._v("A Passion for Clean Linen: 1550–1750")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FIVE")]), _c('br'), _vm._v("The Return of Water: 1750–1815")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SIX")]), _c('br'), _vm._v("Baths and How to Take Them: Europe, 1815–1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SEVEN")]), _c('br'), _vm._v("Wet All Over at Once: America, 1815–1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("EIGHT")]), _c('br'), _vm._v("Soap Opera: 1900–1950")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("NINE")]), _c('br'), _vm._v("The Household Shrine: 1950 to the Present")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/note",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/per",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Text Permissions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/cre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/als",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Katherine Ashenburg")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/006_Ashe_art_r1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 69
// module chunks = 0